import * as common from "./common/index";
import * as admin from "./admin/index";
import * as client from "./client/index";

const isAdmin = import.meta.env.VITE_APP_TYPE === "admin";

// 통일성을 위해 개별 component export X
const BaseButton = isAdmin ? admin.BaseButton : client.BaseButton;
const BaseCheckbox = isAdmin ? admin.BaseCheckbox : client.BaseCheckbox;
const BaseRadio = isAdmin ? admin.BaseRadio : client.BaseRadio;
const BaseTab = isAdmin ? admin.BaseTab : client.BaseTab;
const BaseToggleSwitch = isAdmin ? admin.BaseToggleSwitch : client.BaseToggleSwitch;
const BaseInput = isAdmin ? admin.BaseInput : client.BaseInput;
const BaseSelect = isAdmin ? admin.BaseSelect : client.BaseSelect;
const BaseTable = isAdmin ? admin.BaseTable : client.BaseTable;
const BasePopup = isAdmin ? admin.BasePopup : client.BasePopup;
const BaseSearchForm = isAdmin ? admin.BaseSearchForm : client.BaseSearchForm;

/** client only */
import BasePagination from "./client/BasePagination.vue";

/** Base 객체 */
export const Base = {
  Button: BaseButton,
  Checkbox: BaseCheckbox,
  Radio: BaseRadio,
  Tab: BaseTab,
  ToggleSwitch: BaseToggleSwitch,
  Input: BaseInput,
  Select: BaseSelect,
  Table: BaseTable,
  ExcelDown: common.BaseExcelDown,
  TinyEditor: common.BaseTinyEditor,
  DateInput: common.BaseDateInput,
  File: common.BaseFile,
  TimeInput: common.BaseTimeInput,
  SearchForm: BaseSearchForm,
  Chips: client.BaseChips,
  Popup: BasePopup,
  Pagination: BasePagination,
  CheckLike: client.BaseCheckLike,
  EasyTable: client.BaseTable,
  FilterSelect: client.BaseFilterSelect,
  SelectSearch: client.BaseSelectSearch,
  Textarea: client.BaseTextarea,
  FileUpload: client.BaseFileUpload,
};
